/**
 * 系统管理 菜单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
		<el-form :inline="true" >

			<el-form-item>
				<el-button icon="el-icon-refresh" size="mini" type="primary"></el-button>
				<prems-button size="mini" icon="el-icon-circle-plus-outline" type="primary"  label="添加" perms="sys:menu:add" @click="handleAdd" />

				<!-- <el-button size="mini" icon="el-icon-delete" type="danger">删除</el-button> -->
			</el-form-item>

		</el-form>
		<el-table :header-cell-style="this.$store.state.headerCss" size="small" border row-key="id" :data="allMenus"  :tree-props="{children: 'menus', hasChildren: 'hasChildren'}"  v-loading="loading" border element-loading-text="数据加载中">
			<el-table-column type="index"></el-table-column>
			<el-table-column prop="name" label="名称" width="160" ></el-table-column>
			<el-table-column prop="id" label="Id" width="100"></el-table-column>

			<el-table-column label="图标" width="100" >
				<template slot-scope="scope">
					<i class="iconfont fa menuicon" :class="scope.row.icon"></i>

				</template>
			</el-table-column>
			<el-table-column label="类型"  width="120">
				<template slot-scope="scope">
				  <el-tag v-if="scope.row.resourceType === 1" size="small" type="success">菜单</el-tag>
				  <el-tag v-if="scope.row.resourceType === 2" size="small" >按钮</el-tag>
          <el-tag v-if="scope.row.resourceType === 3" size="small" type="warning">数据</el-tag>
				  <!-- <el-tag v-else-if="scope.row.type === 2" size="small" type="info">按钮</el-tag> -->
				</template>

			</el-table-column>
      <el-table-column  prop="sort" label="排序" >
      </el-table-column>
			<el-table-column label="上级菜单" prop="parentName" width="170"></el-table-column>
			<el-table-column label="菜单URL" prop="url"></el-table-column>
			<el-table-column label="授权标识" prop="permission" width="200"></el-table-column>

			<el-table-column label="操作" min-width="200">

				<template slot-scope="scope">
					<prems-button   icon="el-icon-edit-outline" perms="sys:menu:edit" label="编辑"  size="mini" type="primary" @click="handleEdit(scope.row)" />
					<prems-button icon="el-icon-delete" size="mini" type="danger" @click="deleteModule(scope.row)" perms="sys:menu:del" label="删除" />

				</template>

			</el-table-column>
		</el-table>

		 <!-- 新增修改界面 -->
		<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="40%" :visible.sync="dialogVisible" :close-on-click-modal="false">
		  <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="submitForm()"
		    label-width="80px" style="text-align:left;">
		    <el-form-item label="菜单类型" prop="type">
		      <el-radio-group v-model="dataForm.resourceType" >
		        <el-radio v-for="(type, index) in menuTypeList" :label="index+1"  :key="index" >{{type}} </el-radio>

		      </el-radio-group>
		    </el-form-item>

		    <el-form-item :label="menuTypeList[parseInt(dataForm.resourceType)-1] + '名称'" prop="name">
		      <el-input v-model="dataForm.name" :placeholder="menuTypeList[parseInt(dataForm.resourceType)-1] + '名称'" ></el-input>
		    </el-form-item>
		    <el-form-item label="选择菜单" prop="parentName">
		        <popup-tree-input
		          :data="popupTreeData"
							:props="popupTreeProps"
							:prop="dataForm.parentName==null||dataForm.parentName==''?'顶级菜单':dataForm.parentName"
		          :nodeKey="''+dataForm.parentId"
							:currentChangeHandle="handleTreeSelectChange"
						>
		        </popup-tree-input>
		    </el-form-item>
        <el-form-item label="排序"  v-if="dataForm.resourceType == 1">
          <el-input v-model="dataForm.sort"  ></el-input>
        </el-form-item>
		    <el-form-item v-if="dataForm.resourceType == 2 || dataForm.resourceType == 3 " label="授权标识" prop="permission">
		      <el-input v-model="dataForm.permission" placeholder="如: sys:user:add, sys:user:edit, sys:user:delete"></el-input>
		    </el-form-item>

        <el-form-item v-if="dataForm.resourceType == 3 " label="数据接口" prop="permission">
          <el-input v-model="dataForm.interfaceName" placeholder="数据接口"></el-input>
        </el-form-item>

		    <el-form-item v-if="dataForm.resourceType == 1" label="菜单路由" prop="url">
		      <el-row>
		        <el-col :span="22">
		            <el-input v-model="dataForm.url" placeholder="菜单路由"></el-input>
		        </el-col>
		        <el-col :span="2" class="icon-list__tips">
		            <el-tooltip placement="top" effect="light" style="padding: 10px;">
		              <div slot="content">
		                <p>URL格式：</p>
		                <p>1.常规业务开发的功能URL，如用户管理，Views目录下页面路径为 /Sys/User, 此处填写 /sys/user。</p>
		                <p>2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http:// 不可省略。</p>
		                <p>示例：用户管理：/sys/user 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000</p></div>
		              <i class="el-icon-warning"></i>
		            </el-tooltip>
		        </el-col>
		      </el-row>
		    </el-form-item>

		    <el-form-item v-if="dataForm.resourceType  == 1" label="菜单图标" prop="icon">
		      <el-row>
		        <el-col :span="22">
		          <!-- <el-popover
		            ref="iconListPopover"
		            placement="bottom-start"
		            trigger="click"
		            popper-class="mod-menu__icon-popover">
		            <div class="mod-menu__icon-list">
		              <el-button
		                v-for="(item, index) in dataForm.iconList"
		                :key="index"
		                @click="iconActiveHandle(item)"
		                :class="{ 'is-active': item === dataForm.icon }">
		                <icon-svg :name="item"></icon-svg>
		              </el-button>
		            </div>
		          </el-popover> -->

		          <el-input v-model="dataForm.icon" v-popover:iconListPopover :readonly="false" placeholder="菜单图标名称（如：fa fa-home fa-lg）" class="icon-list__input"></el-input>
		        </el-col>
		        <el-col :span="2" class="icon-list__tips">
		          <fa-icon-tooltip />
		        </el-col>
		      </el-row>
		    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini"  @click="dialogVisible = false">取消</el-button>
		    <el-button size="mini"  type="primary" @click="submitForm()">确定</el-button>
		  </span>
		</el-dialog>


	</div>
</template>

<script>
import PopupTreeInput from "@/components/PopupTreeInput";
import PremsButton from "@/views/permission/PreButtom";
import FaIconTooltip from "@/components/FaIconTooltip";
import {
  ModuleList,
  ModuleGet,
  ModuleNodes,
  MenuSave,
	MenuUpDate,
  ModuleDelete
} from '../../api/userMG'
export default {
  data() {
    return {
			loading: false, //是显示加载
      dialogVisible:false,
      menuTypeList: ["菜单", "按钮","数据"],
      dataForm: {
				name:'',
        resourceType: "",//菜单类型
        url: "",//路径
        permission: "",//受权标识
        parentId: 0,//父级id
        parentName: "",//父级id名称
        icon: "",
        sort:""
        //iconList: []
      },
			dataRule: {
			  name: [{ required: true, message: "菜单名称不能为空", trigger: "blur" }]
				// url:[{ required: true, message: "url不能为空", trigger: "blur" }]

			},
			setFalg:0,//增加还是修改
			allMenus:[],
			popupTreeData: [],
			popupTreeProps: {
			  label: "name",
			  children: "menus"
			}
    }
  },
	components:{
		PopupTreeInput,
		PremsButton,
		FaIconTooltip

	},
  /**
   * 创建完毕
   */

  created() {

    this.getmenu()

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据
    getmenu() {
			ModuleList().then( res => {
				this.loading = false;

				if(res.errCode){
					this.$message.error('数据获取失败，请稍后再试')
					return
				}
				this.allMenus = res.data
				this.popupTreeData = this.getParentMenuTree(this.allMenus);

			})
		},


		// 获取上级菜单树
		getParentMenuTree: function(tableTreeDdata) {
		  let parent = {
		    parentId: 0,
		    name: "顶级菜单",
		    menus: tableTreeDdata
		  };
		  return [parent];
		},

		handleTreeSelectChange:function(data, node) {

		  this.dataForm.parentId = data.id || 0;
		  this.dataForm.parentName = data.name == '顶级菜单'?'':data.name;
		},




    // 显示新增界面
    handleAdd: function() {
      this.dialogVisible = true;
			this.setFalg = 0
      this.dataForm = {


				name:'',
				resourceType: 1,//菜单类型
				url: "",//路径
				permission: "",//受权标识
				parentId: 0,//父级id
				parentName: "",//父级id名称
        interfaceName:"",
				icon: "",
        sort:"",
      };
    },
    // 显示编辑界面
    handleEdit: function(row) {

      this.dialogVisible = true;
			this.setFalg = 1
      Object.assign(this.dataForm, row);
      this.dataForm.sort = row.sort || ''
    },

     // 表单提交
    submitForm:function() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.loading = true;
            let params = Object.assign({}, this.dataForm);
						this.dialogVisible = false
						if(this.setFalg == 1){
							MenuUpDate(params).then(res => {


								if(res.status == 0){
									this.$message.error(res.msg)
									return
								}
                this.loading = false;
								this.$message.success("操作成功")
								this.getmenu()

							});
						}else{
							MenuSave(params).then(res => {


								if(res.status == 0){
									this.$message.error(res.msg)
									return
								}
                this.loading = false;
								this.$message.success("操作成功")
								this.getmenu()

							});
						}


          });
        }
      });
    },


    // 删除菜单
    deleteModule(data) {

			this.$confirm('确定要删除吗?', '信息', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then( ()=> {

				 let parameter = {
					 id:data.id
				 }
				 ModuleDelete(parameter)

				  .then(res => {

						if(res.status == 1){
							this.getmenu()
							this.$message.success('菜单管理列表删除成功！')
						}else{
							this.$message.error(res.msg)
						}
						console.log(res)

				  })
				  .catch(err => {
				    this.$message.error('菜单管理列表删除失败，请稍后再试！')
				  })
			})








    }
  }
}
</script>

<style>


.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
.menuicon{
	font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Module.vue